'use client'

import { HTMLProps, useState } from 'react'
import clsx from 'classnames'
import { Link, usePathname } from '@/routing'
import { IMenuItem } from '@/interfaces/menu'
import ArrowDownIcon from '@/public/arrow-down.svg'
import style from './burger-menu.module.scss'

interface BurgerMenuProps extends HTMLProps<HTMLDivElement> {
  navItems: IMenuItem[]
}

export const BurgerMenu = (props: BurgerMenuProps) => {
  const { className, navItems } = props
  const [openedFolder, setOpenedFolder] = useState('')
  const pathname = usePathname()

  return (
    <nav className={clsx(style.container, 'main-padding', className)}>
      {navItems.map(({ name, url, is_external, is_folder, items }, index) => {
        const isActiveNavLink = pathname.startsWith(url ?? '')

        if (is_folder)
          return (
            <ul
              style={{ '--folder-length': items?.length ?? 0 }}
              className={clsx(style.item, style.folder, 'text', { [style.folderOpen]: openedFolder === name })}
              key={name}
            >
              <h4
                className={clsx(style.subtitle, 'text_type_h2')}
                onClick={() =>
                  setOpenedFolder(prevState => {
                    if (prevState === name) return ''
                    else return name
                  })
                }
              >
                {name}
                <ArrowDownIcon className={style.arrow} />
              </h4>

              {items.map(({ name, url, is_external }) => {
                const isActiveNavLink = pathname.startsWith(url ?? '')

                return (
                  <Link
                    className={clsx(style.subitem, style.link, 'text_type_h2 menu-close-trigger-js')}
                    data-open={isActiveNavLink ? '' : undefined}
                    href={url ?? ''}
                    key={name}
                    target={is_external ? '_blank' : '_self'}
                    rel="noopener noreferrer"
                  >
                    {name}
                  </Link>
                )
              })}
            </ul>
          )

        return (
          <Link
            className={clsx(style.item, style.link, 'text text_type_h2 menu-close-trigger-js')}
            data-open={isActiveNavLink ? '' : undefined}
            href={url ?? ''}
            key={name}
            target={is_external ? '_blank' : '_self'}
            rel="noopener noreferrer"
          >
            {name}
          </Link>
        )
      })}
    </nav>
  )
}
